import React from "react";

/*
  Renders an official payment-brand SVG from /public/brands at a FIXED height.

  Why not a plain <img height=X width="auto">: several of these brand SVGs ship
  with a `viewBox` but no intrinsic width/height, so some browsers report
  naturalWidth:0 and render the <img>'s ALT TEXT instead of the artwork — which
  blows out the layout (e.g. "American Express" / "Tether USDT" as wide text).
  We fix that deterministically by setting an explicit width = height × (viewBox
  aspect ratio), so every mark scales to the design's height and never collapses
  to alt text. Aspect ratios come straight from each asset's viewBox.
*/

// viewBox aspect ratios (width / height) for each brand asset.
const ASPECT = {
  "apple-pay": 52 / 22,
  "google-pay": 54 / 22,
  visa: 48 / 30,
  mastercard: 48 / 30,
  amex: 48 / 30,
  paypal: 64 / 22,
  venmo: 64 / 22,
  bitcoin: 26 / 26,
  ethereum: 26 / 26,
  tether: 26 / 26,
};

export default function BrandMark({ brand, alt, height = 22, style, ...props }) {
  const src = `${process.env.PUBLIC_URL || ""}/brands/${brand}.svg`;
  const width = Math.round(height * (ASPECT[brand] || 1));
  return (
    <img
      src={src}
      alt={alt || brand}
      width={width}
      height={height}
      style={{ height, width, display: "block", flex: "none", ...style }}
      {...props}
    />
  );
}
